<template>
  <div>
    <page-header :title="$t('dictionary.webconsole')" />
    <page-body>
      <list :id="listId" />
    </page-body>
  </div>
</template>

<script>
import List from './components/List'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'NotificationIndex',
  components: {
    List,
  },
  mixins: [WindowsMixin],
  data () {
    return {
      listId: 'NotificationList',
    }
  },
  methods () {},
}
</script>
